import * as actions from 'actions/deviceTesting';

export default function disabledReducer(state = false, action) {
  switch (action.type) {
    case actions.SET_DEVICE_TESTING_DISABLED:
      return action.payload;
    default:
      return state;
  }
}
